import {measureTextSizeFactory} from "../util/dom";
import {fromPixels, toPixels} from "../util/units";
import {debounce} from "../util/debounce";
import {Component} from "./Component";

export class ExpandingInput extends Component {
    static name = "expanding-input";


    constructor(el) {
        super(el);

        this.computedStyle = getComputedStyle(this.el);

        this.textMeasure = measureTextSizeFactory(this.computedStyle);

        this.addEventListener(window, "resize load", debounce(300, (e) => {
            this.computedStyle = getComputedStyle(this.el);
            this.textMeasure = measureTextSizeFactory(this.computedStyle);
        }));

        this.addEventListener(el, "input", (e) => {
            const rect = this.textMeasure(el.value + "M");

            const height = rect.height + fromPixels(this.computedStyle.paddingTop) + fromPixels(this.computedStyle.paddingBottom);

            el.style.setProperty("--height", toPixels(height));
        });

    }

}
